<template lang="pug">
  .Solution
    router-view
</template>

<script>
  import TopTitle from "@/components/topTitle";
  import TopInformations from "@/views/Solution/components/TopInformations/TopInformations";
  import ProjectDesign from "@/views/Solution/components/ProjectDesign/ProjectDesign";
  import ProductAndServer from "@/views/Solution/components/ProductAndServer/ProductAndServer";
  import Framework from "@/views/Solution/components/Framework/Framework";
  import Scene from "@/views/Solution/components/Scene/Scene";
  import BottomFooter from "@/components/bottomFooter";
  export default {
    name: "Solution",
    components: {BottomFooter, Scene, Framework, ProductAndServer, ProjectDesign, TopInformations, TopTitle},
  };
</script>

<style scoped lang="stylus">
  .Solution {
    background-color white
  }
</style>
